import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "bg-gray-lp-2800 border border-gray-lp-1500 rounded-xl pt-3 pb-2 px-5 flex flex-col gap-3" }
const _hoisted_2 = { class: "flex flex-row items-center gap-2" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "bg-green-lp-700 rounded-full h-2.5 w-1" }, null, -1)
const _hoisted_4 = {
  class: "text-sm font-medium text-black-lp-100",
  style: {"line-height":"100%","letter-spacing":"-2%"}
}
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col gap-y-2 items-center py-4"
}
const _hoisted_6 = { class: "text-black-lp-300 font-semibold text-sm" }
const _hoisted_7 = { class: "text-xs text-gray-lp-800 text-center w-full sm:w-60" }
const _hoisted_8 = {
  key: 1,
  class: "flex flex-col gap-2"
}
const _hoisted_9 = { class: "flex flex-col gap-2 items-center justify-center lg:items-start lg:justify-start" }
const _hoisted_10 = { class: "flex flex-row items-center gap-1" }
const _hoisted_11 = {
  class: "text-34px text-black-lp-100 font-bold",
  style: {"line-height":"100%","letter-spacing":"-2%"}
}
const _hoisted_12 = { class: "flex flex-row gap-1 items-center" }
const _hoisted_13 = /*#__PURE__*/_createVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M2.45996 2.6582V6.75279C2.45996 8.96193 4.25082 10.7528 6.45996 10.7528H13.6674M13.6674 10.7528L11.0621 7.98215M13.6674 10.7528L11.0621 13.3347",
    stroke: "#A7A8AA",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_14 = { class: "rounded-xl px-2 py-3 bg-white text-center lg:text-left" }
const _hoisted_15 = { style: {"line-height":"100%","letter-spacing":"-2%"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("dashboard.totalRevenueSection.title")), 1)
    ]),
    (_ctx.data.errorOverview)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("dashboard.totalRevenueSection.systemError")), 1),
          _createVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("dashboard.totalRevenueSection.reloadInstruction")), 1),
          _createVNode("button", {
            class: "flex items-center gap-x-2 text-red-lp-100 text-xs font-semibold focus:outline-none",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('retry')))
          }, [
            _createVNode(_component_Icons, {
              name: "reload",
              class: "w-4"
            }),
            _createVNode("span", null, _toDisplayString(_ctx.$t("dashboard.totalRevenueSection.reload")), 1)
          ])
        ]))
      : (_ctx.data.isLoadingOverview)
        ? (_openBlock(), _createBlock("div", _hoisted_8, [
            _createVNode(_component_Skeleton, {
              height: "2.125rem",
              width: "13.1875rem"
            }),
            _createVNode(_component_Skeleton, { height: "3.125rem" })
          ]))
        : (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _createVNode("h2", _hoisted_11, _toDisplayString(_ctx.formattedMainRevenue), 1),
                _createVNode("div", {
                  class: ["flex flex-row items-center", [{ invisible: _ctx.formattedGrowthPercentage == 0 }]]
                }, [
                  _createVNode(_component_Icons, {
                    name: "arrow-up-medium",
                    class: ["w-5 h-5", [
                { 'text-green-700': _ctx.formattedGrowthPercentage > 0 },
                {
                  'text-red-lp-2000 transform rotate-180':
                    _ctx.formattedGrowthPercentage < 0
                }
              ]]
                  }, null, 8, ["class"]),
                  _createVNode("div", {
                    class: ["font-medium", [
                { 'text-green-700': _ctx.formattedGrowthPercentage > 0 },
                { 'text-red-lp-2000': _ctx.formattedGrowthPercentage < 0 }
              ]]
                  }, _toDisplayString(Math.abs(_ctx.formattedGrowthPercentage)) + "% ", 3)
                ], 2)
              ]),
              _createVNode("div", _hoisted_12, [
                _createVNode("p", {
                  class: ["text-gray-lp-800 text-sm flex flex-row gap-1 items-center", [{ invisible: _ctx.isCompareRevenueZero }]]
                }, [
                  _hoisted_13,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("dashboard.totalRevenueSection.previous")) + " ", 1),
                  _createVNode("strong", null, _toDisplayString(_ctx.formattedCompareRevenue), 1)
                ], 2)
              ])
            ]),
            _createVNode("div", _hoisted_14, [
              _createVNode("p", _hoisted_15, [
                _createVNode("strong", null, _toDisplayString(_ctx.formattedMainStt) + " STT", 1),
                _createVNode("span", {
                  class: ["text-sm font-medium", [
              { invisible: _ctx.formattedSttGrowthPercentage == 0 },
              { 'text-green-700': _ctx.formattedSttGrowthPercentage >= 0 },
              { 'text-red-lp-2000': _ctx.formattedSttGrowthPercentage < 0 }
            ]]
                }, [
                  _createVNode(_component_Icons, {
                    name: "arrow-up-medium",
                    class: ["w-4 h-4 align-text-top", [
                { 'text-green-700': _ctx.formattedSttGrowthPercentage >= 0 },
                {
                  'text-red-lp-2000 transform rotate-180':
                    _ctx.formattedSttGrowthPercentage < 0
                }
              ]]
                  }, null, 8, ["class"]),
                  _createTextVNode(_toDisplayString(Math.abs(_ctx.formattedSttGrowthPercentage)) + "%", 1)
                ], 2),
                _createVNode("span", {
                  class: [[{ invisible: _ctx.isCompareSttZero }], "text-gray-lp-800 text-sm"]
                }, [
                  _createTextVNode("    " + _toDisplayString(_ctx.$t("dashboard.totalRevenueSection.previousLower")) + " ", 1),
                  _createVNode("strong", null, _toDisplayString(_ctx.formattedCompareStt) + " STT", 1)
                ], 2)
              ])
            ])
          ], 64))
  ]))
}